









import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";

@Component
export default class ClassName extends Vue {
  private query: any;
  private json: any;

  mounted() {
    this.query = this.$route.query.json;
    if (this.query) {
      this.json = JSON.parse(this.query);

      if (this.$route.query.code && this.json.appid && this.json.fromUrl) {
        const uri = `${this.json.fromUrl}#/?appid=${this.json.appid}&code=${this.$route.query.code}`;
        // console.log(uri);
        window.location.href = uri;
      } else if (this.json.appid && this.json.fromUrl) {
        this.login();
      }
    }
  }

  login() {
    let json: any;
    this.json = encodeURIComponent(JSON.stringify(this.json));

    const uri = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1554d04d4416855f&redirect_uri=${window
      .location.protocol +
      "//" +
      window.location.host +
      window.location.pathname}?json=${
      this.json
    }&response_type=code&scope=snsapi_base`;
    // console.log(uri);
    window.location.href = uri;
  }
}
